import { IBOAccountItem } from "./IBOAccountItem";

export default IBOAccountItem;
